import React, { createRef } from "react";
import { bool, func } from "prop-types";

const Declaration = ({ hasConsented, setField }) => {
  const acknowldgementInput = createRef();

  return (
    <div className="my-2">
      <div className="btn-group clearfix d-block">
        <label
          style={{
            width: "100%",
            fontSize: "14px",
            display: "block",
            paddingLeft: "2em",
            textIndent: "-1.5em",
          }}
        >
          <input
            ref={acknowldgementInput}
            defaultChecked={hasConsented}
            type="checkbox"
            name={"consent"}
            onClick={() => {
              setField("generalConsent", acknowldgementInput.current.checked);
            }}
            autoComplete="off"
          />
          &nbsp;&nbsp;&nbsp;I confirm that I have answered all questions
          correctly and honestly and I understand that failure to disclose the
          relevant information may result in termination of my assignment. I
          have read the Privacy Policy and understand that my personal data will
          be forwarded to employers and third parties in order for you to check
          my references and provide me with work and payroll services. I agree
          that HRGO Recruitment will deduct monies from my pay to recover any
          accidental overpayment. I am aware the HRGO Recruitment Temporary
          Worker’s Handbook is available online. I understand that it is my
          responsibility to adhere to the policies it contains, including
          timesheet deadlines. I will seek advice from my consultant if there is
          anything I do not understand.
        </label>
      </div>
    </div>
  );
};

Declaration.propTypes = {
  hasConsented: bool.isRequired,
  setField: func.isRequired,
};

Declaration.defaultProps = {
  hasConsented: false,
};

export default Declaration;
